import Currency from '@js/plugins/currency';

export default {
    data() {
        return {
            initialFranchiseCurrency: null,
        };
    },

    computed: {
        franchiseCurrency() {
            return Currency.hasCurrency();
        },
    },

    beforeCreate() {
        this.initialFranchiseCurrency = Currency.hasCurrency();
    },

    methods: {
        getFormattedCurrency(data) {
            const currency =
                this.$store.getters.currency == null
                    ? this.franchiseCurrency
                    : this.$store.getters.currency;

            return `${currency} ${numeral(data).format('0,0.00')}`;
        },

        getCurrency() {
            return this.$store.getters.currency == null
                ? this.franchiseCurrency === undefined
                    ? this.initialFranchiseCurrency
                    : this.franchiseCurrency
                : this.$store.getters.currency;
        },
    },
};
